import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { resolveInputOutline } from '../../styles-system/input-element-utils.esm.js';
import { isFlatDesign } from '../../themes/const.esm.js';
import { transitions } from '../../themes/theme-keys/transitions.esm.js';
import scaleToPx from '../../utils/scale-to-px.esm.js';
import { resolveColor } from '../../utils/styled-props.esm.js';

var hoverStyles = function hoverStyles(theme, showHoverShadow, state, disabled) {
  return {
    ':not([disabled]) + span': _objectSpread2({
      border: 'black',
      boxShadow: 'black.inset'
    }, showHoverShadow ? {
      '::before': {
        opacity: 0.5
      }
    } : {}),
    ':checked + span': resolveInputOutline(theme, state !== null && state !== void 0 ? state : 'primary', true, disabled, 1)
  };
};
var radio = {
  "default": function _default(theme, props) {
    var state = props.state,
      disabled = props.disabled,
      disableBg = props.disableBg,
      disableColor = props.disableColor,
      showHoverShadowProps = props.showHoverShadow,
      hoverShadowColor = props.hoverShadowColor,
      radioBorder = props.radioBorder,
      radioInnerSize = props.radioInnerSize,
      radioInnerColor = props.radioInnerColor;
    var showHoverShadow = showHoverShadowProps || !!hoverShadowColor;
    var isFlatDesign$1 = isFlatDesign(theme);
    return {
      '& + span': _objectSpread2(_objectSpread2(_objectSpread2({
        width: '1em',
        height: '1em',
        position: 'relative',
        transition: 'box-shadow 250ms ease 0s'
      }, radioBorder ? {
        border: radioBorder
      } : resolveInputOutline(theme, state !== null && state !== void 0 ? state : 'neutrals.13')), {}, {
        borderRadius: '100%'
      }, showHoverShadow ? {
        '::before': {
          content: '""',
          height: '2em',
          width: '2em',
          position: 'absolute',
          bg: hoverShadowColor !== null && hoverShadowColor !== void 0 ? hoverShadowColor : 'neutrals.18',
          borderRadius: '100%',
          opacity: 0,
          transition: transitions.create('opacity', {
            duration: transitions.duration["short"]
          })
        }
      } : {}), {}, {
        '::after': {
          content: '""',
          height: scaleToPx(radioInnerSize !== null && radioInnerSize !== void 0 ? radioInnerSize : '0.6em'),
          width: scaleToPx(radioInnerSize !== null && radioInnerSize !== void 0 ? radioInnerSize : '0.6em'),
          position: 'absolute',
          bg: disabled ? 'neutrals.17' : radioInnerColor !== null && radioInnerColor !== void 0 ? radioInnerColor : 'primary',
          borderRadius: '100%',
          transform: 'scale(0)',
          transition: transitions.create('transform', {
            duration: transitions.duration["short"]
          })
        }
      }),
      '&:checked + span': _objectSpread2(_objectSpread2({}, radioBorder ? {
        border: radioBorder
      } : resolveInputOutline(theme, state !== null && state !== void 0 ? state : 'primary')), {}, {
        '::after': {
          transform: 'scale(1)'
        }
      }),
      '&:hover': hoverStyles(theme, showHoverShadow, state, disabled),
      '&.is-hover': hoverStyles(theme, showHoverShadow, state, disabled),
      '&.is-active + span': resolveInputOutline(theme, (state !== null && state !== void 0 ? state : isFlatDesign$1) ? 'primary.moderate' : 'primary', false, disabled, 4),
      '&:focus + span': resolveInputOutline(theme, (state !== null && state !== void 0 ? state : isFlatDesign$1) ? 'primary.moderate' : 'primary', false, disabled, 4),
      '&:disabled': {
        '+ span': {
          cursor: 'not-allowed'
        },
        '.is-read-only + span + span': {
          cursor: 'auto'
        },
        ':not(.is-read-only) + span + span': {
          cursor: 'not-allowed'
        },
        ':not(.is-read-only) ~ span': {
          opacity: 0.6
        },
        ':checked + span': _objectSpread2(_objectSpread2({
          color: disableColor !== null && disableColor !== void 0 ? disableColor : 'neutral.dark'
        }, resolveInputOutline(theme, disableBg !== null && disableBg !== void 0 ? disableBg : 'neutral.light')), {}, {
          backgroundColor: resolveColor(theme, disableBg !== null && disableBg !== void 0 ? disableBg : 'neutral.light'),
          '::after': {
            bg: 'neutral'
          }
        }),
        ':not([checked]) + span': resolveInputOutline(theme, disableBg !== null && disableBg !== void 0 ? disableBg : 'neutral.light')
      }
    };
  }
};

export default radio;
//# sourceMappingURL=variants.esm.js.map
